import { signal } from '@preact/signals-react'
import { THomeTab } from './homeTabs'

/**
 * The signal that represents the selected home tab.
 */
export const homeTabSignal = signal<THomeTab>('itinerary')
